import React, { Component } from "react";
import { connect } from "react-redux";

import "./GymRegistration.css";

import { callAPI } from "../../assets/Js/backendCommunication";
import { withRouter } from "react-router-dom";
import { Spinner } from "../../Components/Spinner/Spinner";

import addGymAccountId from "../../redux/actionCreators/addGymAccountId";

import { emailRegex } from "../../assets/Js/regex";
import { passwordRegex } from "../../assets/Js/regex";
import { phoneRegex } from "../../assets/Js/regex";
import { imageRegex } from "../../assets/Js/regex";

import projectSettings from "../../assets/Js/projectSettings";

import { apiResponseToast } from "../../assets/Js/apiResponseToast";

import UnitEnum from "../../assets/Js/UnitEnum";

const mapDispatchToProps = (dispatch) => {
  return {
    addGymId: (payload) => dispatch(addGymAccountId(payload)),
  };
};

export default connect(
  null,
  mapDispatchToProps
)(
  withRouter(
    class GymRegistrationPersonalInfoForm extends Component {
      constructor(props) {
        super(props);

        this.state = {
          passwordResult: false,
          passwordNotConfirmed: false,
          phoneRightFormat: false,
          emailRightFormat: false,
          imageRightFormat: false,
          isLoading: false,
          data: {
            firstName: "",
            lastName: "",
            email: "",
            password: "",
            confirmPassword: "",
            gender: "male",
            phoneNumber: "",
            image: "",
            Unit: UnitEnum.lbs,
          },
        };
      }

      submitHandler = async (e) => {
        e.preventDefault();

        let {
          firstName,
          lastName,
          email,
          password,
          confirmPassword,
          gender,
          phoneNumber,
          image,
        } = this.state.data;

        await this.setState({ emailRightFormat: !emailRegex.test(email) });

        await this.setState({ passwordResult: !passwordRegex.test(password) });

        await this.setState({
          passwordNotConfirmed: confirmPassword !== password,
        });

        await this.setState({
          phoneRightFormat: !phoneRegex.test(phoneNumber),
        });

        if (image) {
          await this.setState({
            imageRightFormat: !imageRegex.test(image.name),
          });
        }

        if (
          !this.state.imageRightFormat &&
          !this.state.phoneRightFormat &&
          !this.state.passwordNotConfirmed &&
          !this.state.passwordResult &&
          !this.state.emailRightFormat
        ) {
          this.backendCommunication();
        }
      };

      backendCommunication = async () => {
        let url = `${projectSettings.baseUrl}/users/create`;
        let type = "POST";
        let header = false;
        let token = null;

        let {
          firstName,
          lastName,
          email,
          password,
          confirmPassword,
          gender,
          phoneNumber,
          image,
          Unit,
        } = this.state.data;

        let formData = new FormData();

        formData.append("FirstName", firstName);
        formData.append("LastName", lastName);
        formData.append("Email", email);
        formData.append("Password", password);
        formData.append("ConfirmPassword", confirmPassword);
        formData.append("Gender", gender);
        formData.append("PhoneNumber", phoneNumber);
        if (image) {
          formData.append("Image", image);
        }
        formData.append("Weight", Unit);
        formData.append("IsAthlete", false);

        let response = "";

        if (response === "") {
          this.setState({ isLoading: true });
        }

        response = await callAPI(url, header, type, formData, token);

        if (response) {
          apiResponseToast(
            response.status,
            "gymPersonalRegistraion",
            response.data.message
          );

          this.setState({ isLoading: false });
          if (response.type === "error") {
          } else if (response.type === "success") {
            if (this.props.paramName && this.props.paramValue) {
              this.props.history.push(
                `/gymregistrationgymcreationform?${this.props.paramName}=${this.props.paramValue}`
              );
            } else {
              this.props.history.push(
                `/gymregistrationgymcreationform/${response?.data?.Id}`
              );
            }

            response = "";
          }
        }
      };

      render() {
        return (
          <form
            className="forms-sample pl-3 pr-3 pt-2 pb-1"
            onSubmit={this.submitHandler}
          >
            <div className="row">
              <div className="formGroup col-md-6 col-12">
                <div className="mr-1">
                  <label htmlFor="firstName">First Name</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="firstName"
                    placeholder="First Name"
                    required
                    onChange={(e) =>
                      this.setState({
                        data: { ...this.state.data, firstName: e.target.value },
                      })
                    }
                  />
                </div>
              </div>
              <div className="formGroup col-md-6 col-12">
                <div className="ml-1">
                  <label htmlFor="lastName">Last Name</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="lastName"
                    placeholder="Last Name"
                    required
                    onChange={(e) =>
                      this.setState({
                        data: { ...this.state.data, lastName: e.target.value },
                      })
                    }
                  />
                </div>
              </div>
            </div>
            <div className="formGroup">
              <label htmlFor="email">Email</label>
              {this.state.emailRightFormat ? (
                <span className="text-danger small ml-1">Incorrect Format</span>
              ) : null}
              <input
                type="email"
                className="form-control form-control-sm"
                id="email"
                placeholder="example@example.com"
                required
                onChange={(e) =>
                  this.setState({
                    data: { ...this.state.data, email: e.target.value },
                  })
                }
              />
            </div>
            <div className="formGroup">
              <label htmlFor="password">Password</label>
              {this.state.passwordResult ? (
                <span className="text-danger small ml-1">
                  Minimum 8 characters, with at least 1 capital and 1 lower
                  letter <br />
                  number and special character
                </span>
              ) : null}
              <input
                type="password"
                className="form-control form-control-sm"
                id="password"
                placeholder="Password"
                required
                onChange={(e) =>
                  this.setState({
                    data: { ...this.state.data, password: e.target.value },
                  })
                }
              />
            </div>
            <div className="formGroup">
              <label htmlFor="confirmPassword">Confirm Password</label>
              {this.state.passwordNotConfirmed ? (
                <span className="text-danger small ml-1">
                  Passwords Donot Match
                </span>
              ) : null}
              <input
                type="password"
                className="form-control form-control-sm"
                id="confirmPassword"
                placeholder="Confirm Password"
                required
                onChange={(e) =>
                  this.setState({
                    data: {
                      ...this.state.data,
                      confirmPassword: e.target.value,
                    },
                  })
                }
              />
            </div>
            <div className="formGroup">
              <label htmlFor="gender">Gender</label>
              <select
                className="form-control selectField"
                id="gender"
                onChange={(e) =>
                  this.setState({
                    data: {
                      ...this.state.data,
                      gender: e.target.value.toLowerCase(),
                    },
                  })
                }
              >
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
            </div>
            <div class="formGroup">
              <label htmlFor="unit">Weight Preference</label>
              <select
                class="form-control selectField"
                id="unit"
                onChange={(e) =>
                  this.setState({
                    data: {
                      ...this.state.data,
                      Unit: e.target.value.toLowerCase(),
                    },
                  })
                }
              >
                <option value={UnitEnum.lbs}>Lbs</option>
                <option value={UnitEnum.kg}>Kg</option>
              </select>
            </div>
            <div className="formGroup">
              <label htmlFor="phoneNumber">Phone</label>
              {this.state.phoneRightFormat ? (
                <span className="text-danger small ml-1">
                  Phone number must contain digits
                </span>
              ) : null}
              <div className="d-flex align-items-center">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="phoneNumber"
                  placeholder="Mobile number"
                  minLength="10"
                  maxlength="15"
                  required
                  onChange={(e) =>
                    this.setState({
                      data: { ...this.state.data, phoneNumber: e.target.value },
                    })
                  }
                />
              </div>
            </div>
            {this.state.imageRightFormat ? (
              <span className="text-danger small ml-1">
                Supported Formats gif, jpg, jpeg, png
              </span>
            ) : null}
            <div className="formGroup">
              <label>Personal Image</label>
              <div className="custom-file">
                <input
                  type="file"
                  className="custom-file-input"
                  id="image"
                  accept="image/*"
                  onChange={(e) =>
                    this.setState({
                      data: { ...this.state.data, image: e.target.files[0] },
                    })
                  }
                />
                <label
                  className="fileInputBtn customFieldLableForm1 custom-file-label text-secondary"
                  for="customFileLang"
                >
                  {typeof this.state.data.image === "object" &&
                  this.state.data.image.name ? (
                    <span>{this.state.data.image.name}</span>
                  ) : (
                    <span>Upload Image</span>
                  )}
                </label>
              </div>
            </div>
            <div className="mx-auto width-fit-content mt-3 mb-3 text-white">
              <button
                type="submit"
                className="basicBtnStyle primaryBtn"
                disabled={this.state.isLoading}
              >
                {this.state.isLoading ? <Spinner /> : <span>Next</span>}
              </button>
            </div>
          </form>
        );
      }
    }
  )
);
